import type {Message} from "@khan/guide-types";
import {doNotTranslateYet} from "@khan/i18n";

import {useCoachDetails} from "../queries/use-coach-details-query.ts";

/**
 * Updates the guide acknowledgement tips message  with `parents`, `teachers` or `parents and teachers`
 * depending on the type of coach they have
 *
 * @returns Message
 */
export function useDynamicCoachMessage(): Message {
    const {parents, teachers} = useCoachDetails();

    const hasParents = parents && parents.length > 0;
    const hasTeachers = teachers && teachers.length > 0;

    const coachType = (() => {
        if (hasParents && hasTeachers) {
            return "parents and teachers";
        }
        if (hasParents) {
            return "parents";
        }
        if (hasTeachers) {
            return "teachers";
        }
        return "parents and teachers";
    })();

    return {
        text: doNotTranslateYet`Few tips on using me safely.
- Remember your ${coachType} can see our messages.
- Please do not include any personal details in your messages to me.` as string,
        user: "Teacher",
        type: "incoming",
        serverOnly: false,
        uiOnly: false,
        interactionId: "",
    };
}
